// extracted by mini-css-extract-plugin
export var table = "_wc-0";